import React from 'react';
import {useLoaderData} from "react-router-dom";
import {usePreloadedQuery} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import DetailsPageHeader from "../../components/common/headers/DetailsPageHeader";
import {Col, Row} from "react-bootstrap";
import LocationInfo from "./LocationInfo";
import LocationVersions from "./versions/LocationVersions";
import DeletePanel from "../../components/common/repeated-page-panels/DeletePanel";
import {useUser} from "../../hooks/useUser";
import LocationContactPoints from "./contactPoints/LocationContactPoints";
import LocationPractitioners from "./practitioners/LocationPractitioners";
import LocationBillingGroups from "./billingGroups/LocationBillingGroups";
import LocationFacilities from "./facilities/LocationFacilities";

const LocationDetails = () => {
    const loader = useLoaderData();
    const data = usePreloadedQuery(graphql`
    query LocationDetailsQuery($id: ID!) {
        node(id: $id) {
            id
            ... on Location {
                applicableVersion {
                    name
                }
                billingGroup {
                    id
                    legalContract {
                        practitioners {
                            ...PractitionerFragments_PractitionerDropdown
                        }
                        linesOfService {
                            ...ContractLinesOfServiceFragments_LinesOfService
                        }
                        billingGroups {
                            ...BillingGroupFragments_BillingGroupDropdown
                        }
                        facilities {
                            ...FacilityFragments_FacilitiesDropdown
                        }
                    }
                }
                ...LocationInfo_Location
                versions {
                    ...LocationVersions_Version
                }
                contactPoints {
                    ...LocationContactPoints_ContactPoints
                }
                practitioners {
                    ...LocationPractitioners_Practitioners
                }
                facilities {
                    ...LocationFacilities_Facilities
                }
		billingGroups {
                    ...LocationBillingGroups
                    }
            }
        }
        allBillingGroups {
            ...BillingGroupFragments_BillingGroupDropdown
        }
        allCounties {
            ...Fragments_AllCountiesDropdown
        }
        allContactPointSystemCodes {
            ...Fragments_AllContactPointSystemCodesDropdown
        }
        allContactPointUseCodes {
            ...Fragments_AllContactPointUseCodesDropdown
        }
    }`, loader.locationDetailsQuery);
    const deleteMutation = graphql`
    mutation LocationDetailsDeleteMutation($id: ID!) {
        deleteNode(input: {id: $id}) {
                deletedNodeId @deleteRecord
        }}`;
    const {hasPermission} = useUser();
    return (
        <>
            <DetailsPageHeader iconText={"Location"} iconType={"map-pin"} title={data.node.applicableVersion.name} />
            <Row className={"mb-3"}>
                <Col>
                    <LocationInfo location={data.node} billingGroups={data.node.billingGroup.legalContract.billingGroups} counties={data.allCounties} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <LocationVersions versions={data.node.versions} locationId={data.node.id} />
                </Col>
            </Row>
            {(hasPermission("PractitionerLocation.Read") || hasPermission("FacilityLocation.Read"))  && <Row>
                {hasPermission("PractitionerLocation.Read") && <Col>
                <LocationPractitioners locationId={data.node.id} 
                                       practitioners={data.node.practitioners}
                                       allBillingGroups={data.node.billingGroup.legalContract.billingGroups}
                                       allPractitioners={data.node.billingGroup.legalContract.practitioners}
                                       availableLineOfServices={data.node.billingGroup.legalContract.linesOfService} 
                />
                </Col>}
                {hasPermission("FacilityLocation.Read") && <Col>
                    <LocationFacilities locationId={data.node.id}
                                        facilities={data.node.facilities}
                                        allBillingGroups={data.node.billingGroup.legalContract.billingGroups}
                                        allFacilities={data.node.billingGroup.legalContract.facilities}
                                        availableLinesOfService={data.node.billingGroup.legalContract.linesOfService}
                    />
                </Col>}
                                       
            </Row>}
            <Row>
                {hasPermission("LocationContactPoint.Read") && <Col>
                    <LocationContactPoints
                        locationId={data.node.id}
                        contactPoints={data.node.contactPoints}
                        contactPointSystemCodes={data.allContactPointSystemCodes}
                        contactPointUseCodes={data.allContactPointUseCodes}
                    />
                </Col>
                }
            </Row>
            {hasPermission("Location.Delete") &&
                <DeletePanel mutation={deleteMutation} redirectUrl={"/locations"} thingToDelete={"Location"} id={data.node.id}>
                    In order to delete a Location, there must be only 1 Location Version and no other related data
                </DeletePanel>}
        </>
    )
}
export default LocationDetails
